/**
 * @module: 任务选择项目和看板数据
 * @author: yuanxm
 * @date: 2020-06-01 15:17:56
 */

import { observable, computed, action } from 'mobx';
import { IProject } from '@src/entity/company/task';
import { IKanbanItem, IMemberItem } from '@src/entity/company/project';
import { ajax } from '@clouderwork/ywk';
import _ from 'lodash';
import { Toast } from 'antd-mobile';

class TaskProject {
  // 我负责和参与的
  @observable joinedProjects: IProject[] = [];
  // 我创建的
  @observable ownProjects: IProject[] = [];
  // 看板数据
  @observable kanbans: IKanbanItem[] = [];
  // 成员数据
  @observable members: IMemberItem[] = [];
  // 选择的项目
  @observable curproject?: IProject;
  // 选择的看板
  @observable curkanban?: IKanbanItem;

  @computed
  get projects(): IProject[] {
    return _.uniqBy([...this.joinedProjects, this.ownProjects] as any[], 'uuid');
  }

  @action.bound
  setCurData(project?: IProject, kanban?: IKanbanItem) {
    this.curproject = project;
    this.curkanban = kanban;
  }

  /**
   * 获取项目列表
   *
   * @param {number} mode 查询的类型:
   *    1-我负责和参与的项目 2-我关注的项目 3-我创建的项目 4-我下属的项目
   * @returns
   */
  async getProjects(mode: number) {
    try {
      const res: any = await ajax.getJson('/company/api/projects', {
        mode
      });
      if (res.error_code === 0) {
        const projects = res.result;
        if (mode === 1) {
          this.joinedProjects = projects;
        } else if (mode === 3) {
          this.ownProjects = projects;
        }
      }
      return res;
    } catch (error) {
      return error;
    }
  }

  /**
   * 获取项目看板列表
   *
   * @param {string} uuid 项目uuid
   * @returns
   */
  async getKanbans(uuid: string) {
    try {
      const res: any = await ajax.getJson(`/company/api/kanbans/project/${uuid}`);
      if (res.error_code === 0) {
        this.kanbans = res.result;
      } else {
        Toast.fail(res.msg, 1);
      }
      return res;
    } catch (error) {
      return error;
    }
  }

  /**
   * 获取项目成员列表
   *
   * @param {string} uuid
   * @returns
   * @memberof Project
   */
  async getMembers(uuid: string) {
    try {
      const res: any = await ajax.getJson(`/company/api/project/members/${uuid}`);
      if (res.error_code === 0) {
        this.members = res.result;
      } else {
        Toast.fail(res.msg, 1);
      }
      return res;
    } catch (error) {
      return error;
    }
  }
}

export default TaskProject;
